'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalProductTableComponent = exports.rentalProductTableComponent = {
    template: require('./rental-product-table.html'),
    bindings: {
        rentalProducts: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.filteredRentalProducts = vm.rentalProducts.filter(function (p) {
                return p.productType === 'RENTAL';
            });
            vm.filteredPortalProducts = vm.rentalProducts.filter(function (p) {
                return p.productType === 'PORTALPRODUCT';
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-product-table.js
// module id = 998
// module chunks = 0